/* eslint-disable react/no-access-state-in-setstate */
import React, { PureComponent } from 'react';
import FormContainer from '../../../FormContainer/FormContainer';
import { addAffiliateState } from './defaultState';
import { handleFormObjectChange } from '../../../Utilities/HandleFormObjectChange';
import { NetworkRequest } from '../../../Utilities/NetworkRequests/NetworkRequests';
import { formatSubmitValues } from '../../../Utilities/SubmitHelper/FormatForSubmit';
import { validateForSubmit } from '../../../Utilities/ValidationHelper/ValidateForm';

export default class AddAffiliate extends PureComponent {
  state = {
    formValues: addAffiliateState(),
    submitting: false,
    dialog: {
      message: '',
      type: 'error',
      title: 'Error'
    }
  };

  handleChange = (field, value) => {
    const formValues = handleFormObjectChange(field, value, {
      ...this.state.formValues
    });
    this.setState({ formValues });
  };

  toggleDialog = (message = '', type = 'error', title = 'Error') => {
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });
    if (message === '' && type === 'success') {
      this.props.toggleDrawer();
    }
  };

  handleSubmit = () => {
    const { valid, messages } = validateForSubmit(this.state.formValues);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return false;
    }
    this.handleSubmitRequest();
  };

  handleSubmitRequest = () => {
    const { formValues } = this.state;
    this.setState({ submitting: true }, () =>
      NetworkRequest(
        'affiliates',
        formatSubmitValues(formValues),
        'addAffiliate'
      )
        .then(({ data }) => this.handleResponse(data))
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleResponse = (data) => {
    this.setState({ submitting: false });
    if (data) {
      this.toggleDialog(
        data.message,
        data.success ? 'success' : 'error',
        data.success ? 'Success' : 'Error'
      );
    } else {
      this.toggleDialog('An error has happened', 'error', 'Error');
    }
  };

  render() {
    const { formValues, submitting, dialog } = this.state;
    return (
      <FormContainer
        formValues={formValues}
        submitting={submitting}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        inputWidth={8}
        separateBlock
        dialog={dialog}
        toggleDialog={this.toggleDialog}
      />
    );
  }
}
